

// object to store loaded CSS chunks
var installedCssChunks = {
	"main": 0
}
__webpack_require__.f.compat = (chunkId, promises) => {


	// extract-css-chunks-webpack-plugin CSS loading
	var supportsPreload = (function() { try { return document.createElement("link").relList.supports("preload"); } catch(e) { return false; }}());
	var cssChunks = {"intltelinput":1,"app":1,"src_index_css-src_core_utils_currency_ts-src_core_utils_getMarketName_ts-src_core_utils_membe-416ec3":1,"replay":1,"shepherd":1};
	if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
	else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
		promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
			var href = "./css/chartiq-" + {"firebase":"79067a4f5e3b387ca718","chartiq":"1336fde4d5475a30660a","intltelinput":"337821c80c7f8cd53d8f","trading":"5f1c8c9f3e7ee1ddffc0","alert":"81badf02a82a30743777","app":"5b3026d78b5310883297","src_core_GC_Permissions_ts":"bdc32c838fdfd39f5fbd","src_index_css-src_core_utils_currency_ts-src_core_utils_getMarketName_ts-src_core_utils_membe-416ec3":"10cb056a2de8ab45cf4a","tradeHistory":"8fade07156a3dffe65d6","src_core_utils_gcFirebase_js-_799b0":"c46ad18b25ce6d16927e","src_releaseNotes_releaseNotes_ts":"970090c331246e99f840","src_patternCreation_patternCreation_ts":"b79a20afda7bb970990d","src_core_utils_gcFirebase_js-_799b1":"7f4caa442537c6d7c637","gtf":"48d8e34309c2dbdddafd","replay":"94f6cc5653e02e014bbd","shepherd":"58fed4c9aafe9ca98743","lotSize":"bdbc2ce3b3245e816de8"}[chunkId] + ".css";
			var fullhref = __webpack_require__.p + href;
			var existingLinkTags = document.getElementsByTagName("link");
			for(var i = 0; i < existingLinkTags.length; i++) {
				var tag = existingLinkTags[i];
				var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
				if((tag.rel === "stylesheet" || tag.rel === "preload") && (dataHref === href || dataHref === fullhref)) return resolve();
			}
			var existingStyleTags = document.getElementsByTagName("style");
			for(var i = 0; i < existingStyleTags.length; i++) {
				var tag = existingStyleTags[i];
				var dataHref = tag.getAttribute("data-href");
				if(dataHref === href || dataHref === fullhref) return resolve();
			}
			var linkTag = document.createElement("link");
			linkTag.rel = supportsPreload ? "preload": "stylesheet";
			supportsPreload ? linkTag.as = "style" : linkTag.type = "text/css";
			linkTag.onload = resolve;
			linkTag.onerror = function(event) {
				var request = event && event.target && event.target.src || fullhref;
				var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
				err.code = "CSS_CHUNK_LOAD_FAILED";
				err.request = request;
				delete installedCssChunks[chunkId]
				linkTag.parentNode.removeChild(linkTag)
				reject(err);
			};
			linkTag.href = fullhref;

			var head = document.getElementsByTagName("head")[0]; head.appendChild(linkTag)
		}).then(function() {
			installedCssChunks[chunkId] = 0;
			if(supportsPreload) {
				var execLinkTag = document.createElement("link");
				execLinkTag.href =  __webpack_require__.p + "./css/chartiq-" + {"firebase":"79067a4f5e3b387ca718","chartiq":"1336fde4d5475a30660a","intltelinput":"337821c80c7f8cd53d8f","trading":"5f1c8c9f3e7ee1ddffc0","alert":"81badf02a82a30743777","app":"5b3026d78b5310883297","src_core_GC_Permissions_ts":"bdc32c838fdfd39f5fbd","src_index_css-src_core_utils_currency_ts-src_core_utils_getMarketName_ts-src_core_utils_membe-416ec3":"10cb056a2de8ab45cf4a","tradeHistory":"8fade07156a3dffe65d6","src_core_utils_gcFirebase_js-_799b0":"c46ad18b25ce6d16927e","src_releaseNotes_releaseNotes_ts":"970090c331246e99f840","src_patternCreation_patternCreation_ts":"b79a20afda7bb970990d","src_core_utils_gcFirebase_js-_799b1":"7f4caa442537c6d7c637","gtf":"48d8e34309c2dbdddafd","replay":"94f6cc5653e02e014bbd","shepherd":"58fed4c9aafe9ca98743","lotSize":"bdbc2ce3b3245e816de8"}[chunkId] + ".css";
				execLinkTag.rel = "stylesheet";
				execLinkTag.type = "text/css";
				document.body.appendChild(execLinkTag);
			}
		}));
	}
};